export function BellIcon({ size = 20, ...props }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            {...props}
        >
            {/* Bell body */}
            <path d="M18 8a6 6 0 1 0-12 0c0 7-3 8-3 8h18s-3-1-3-8" />
            {/* Clapper */}
            <path d="M10.5 20a1.5 1.5 0 0 0 3 0" />
        </svg>
    );
}

export function BellOffIcon({ size = 20, ...props }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            {...props}
        >
            {/* Bell (same shape, slightly adjusted for slash visibility) */}
            <path d="M18 8a6 6 0 0 0-9.6-4.7" />
            <path d="M6 8c0 7-3 8-3 8h15" />
            <path d="M10.5 20a1.5 1.5 0 0 0 3 0" />

            {/* Slash */}
            <path d="M4 4l16 16" />
        </svg>
    );
}